export const inspectTable = [
  {
    id: 1,
    content: '발생하는 화염 또는 스파크 등이 인근 공정설비에 영향이 있다고 판단되는 범위의 지역을 작업구역으로 표시하였다.',
    is_checked: ''
  },
  {
    id: 2,
    content: '화기·용접작업 장소에 근로자의 통행·출입을 제한한다.',
    is_checked: ''
  },
  {
    id: 3,
    content: '화기작업 전에 작업 대상기기 및 작업구역 내에서 인화성 물질 및 독성 물질의 가스 농도를 측정하여 허가서에 기록한다.',
    is_checked: ''
  },
  {
    id: 4,
    content: '불꽃을 발생하는 내연설비의 장비나 차량 등은 작업구역 내 근로자의 출입을 통제한다.',
    is_checked: ''
  },
  {
    id: 5,
    content: '화기작업을 수행하기 위하여 밸브를 차단하거나 맹판을 설치할 때에는 차단하는 밸브에 밸브 잠금 표지 및 맹판 설치 표지를 부착한다.',
    is_checked: ''
  },
  {
    id: 6,
    content: '화학설비 등의 내부에서 화기작업을 수행할 경우에는 배관 및 설비 내의 위험물질을 완전히 비우고 세정한 후에 작업을 수행하고 있다.',
    is_checked: ''
  },
  {
    id: 7,
    content: '밀폐(제한)공간에서의 작업을 수행할 때에는 작업 전에 밀폐공간 내의 공기를 외부의 신선한 공기로 충분히 치환하는 등의 조치(강제 환기 등) 실시한다.',
    is_checked: ''
  },
  {
    id: 8,
    content: '용접불티 비산방지 덮개 또는 용접 방화포 등 불꽃 비산 방지조치를 하고 개방된 맨홀과 하수구(Sewer) 등은 덮거나 닫는다.',
    is_checked: ''
  },
  {
    id: 9,
    content: '화재감시자를 지정하여 화기작업을 시작하기 전과 작업 도중 안전 상태를 확인하도록 한다.',
    is_checked: ''
  },
  {
    id: 10,
    content: '작업 중에 수시로 가스 농도를 측정한다.(분진이 있는 장소는 분진농도를 추가로 측정)',
    is_checked: ''
  },
  {
    id: 11,
    content: '화기작업 전에 이동식 소화기 등을 비치한다.',
    is_checked: ''
  },
  {
    id: 12,
    content: '위 안전조치가 모두 조치되었음을 확인한 후에 작업을 시작하도록 관리한다.',
    is_checked: ''
  },
]
